<template>
  <footer class="main-footer ml-0">
    <div class="float-right d-none d-sm-block">Версия 1.0.0</div>
    &copy; {{ new Date().getFullYear() }}
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
};
</script>
<style lang="scss" scoped>
@media (max-width: 1440px) {
  .main-footer {
    padding: 0.5rem 1rem;
  }
}
</style>
